import axios from 'axios';
const CONTROLLER_PATH = 'Incident';
class IncidentService {
    //CREATE
    create(formData) {
        return axios
            .post(CONTROLLER_PATH, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((response) => response.data);
    }

    pushDocumentsToOldAccountModel(patientId, oldAccountId) {
        return axios.put(CONTROLLER_PATH + '/PushDocumentsToOldAccountModel/' + patientId + '/' + oldAccountId).then((response) => response.data);
    }

    addNote(incidentId, text) {
        return axios.put(CONTROLLER_PATH + '/' + incidentId + '/addNote', {text: text}).then((response) => response.data);
    }

    //READ
    get(id, urlParameters, requestId) {
        return axios.get(CONTROLLER_PATH + (id ? '/' + id : ''), {params: urlParameters, requestId: requestId}).then((response) => ({
            data: response.data,
            requestId: response.config.requestId,
        }));
    }

    getAgeing(urlParameters) {
        return axios.get(CONTROLLER_PATH + '/ageing', {params: urlParameters}).then((response) => response.data);
    }

    getageingmanagement(urlParameters) {
        return axios.get(CONTROLLER_PATH + '/getageingmanagement', {params: urlParameters}).then((response) => response.data);
    }

    getmanagementcaseadministratorwidget(urlParameters) {
        return axios.get(CONTROLLER_PATH + '/getmanagementcaseadministratorwidget', {params: urlParameters}).then((response) => response.data);
    }

    getmanagementarearepresentativewidget(urlParameters) {
        return axios.get(CONTROLLER_PATH + '/getmanagementarearepresentativewidget', {params: urlParameters}).then((response) => response.data);
    }
    
    getIncidentPatient(identityId) {
        return axios.get(CONTROLLER_PATH + '/incidentpatient/identity/' + identityId).then((response) => response.data);
    }

    //UPDATE
    update(id, formData) {
        return axios
            .put(CONTROLLER_PATH + '/' + id, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((response) => response.data);
    }

    //DELETE
    delete(id) {
        return axios.delete(CONTROLLER_PATH + '/' + id).then(() => {});
    }
}

export default new IncidentService();
